<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CollectionList from "@/components/widgets/collection-list.vue";
import VerificationCode from "@/components/modals/verification-code.vue";
import PrintOptions from "@/components/modals/print-options";
import { Carousel, Slide } from "vue-carousel";
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import Swal from "sweetalert2";
import CollectionModal from "@/components/modals/collection-modal.vue";

export default {
  page: {
    title: "Collection",
  },
  components: {
    Layout,
    PageHeader,
    CollectionList,
    VerificationCode,
    PrintOptions,
    Carousel,
    Slide,
    DatePicker,
    CollectionModal
  },
  data() {
    return {
      title: "Collections",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Collections",
          active: true,
        },
      ],
      verificationType: "collection-voiding",
      collections: [],
      loading: false,
      tabModel: 0,
      reportList: false,
      selectedRange: [new Date(), new Date()],
      slideNum: 1,
      reportSelection: '',
      userProfile: {},
      fees: [],
      fundSources: [],
      modalTitle: "Add Collection",
    };
  },
  validations: {
    selectedRange: { required },
  },
  async created(){
    this.loading = true;
    this.getFundSources(this.$store.state.data.selectedCampus.id);
    this.fetchFees(this.$store.state.data.selectedCampus.id);
    await this.getUser();
    await this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
    this.loading = false;
  },
  methods: {
    async getFundSources(campusId) {
      await this.$store
        .dispatch("fundsource/GetFundSourcesByCampusId", campusId)
        .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.fundSources = res.data;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async fetchFees(campusId) {
      await this.$store
          .dispatch("fee/getFeesByCampus", campusId)
          .then((res) => {
              if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
              }
              res.data.map(item => {
                item.selected = false;
              });
              this.fees = res.data;
          })
      .catch((error) => {
          this.showToast("Cannot fetch fees. Please contact your administrator", "error");
      });
    },
    async getUser() {
      await this.$store
        .dispatch("account/GetProfile")
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.userProfile = res.data;
        })
        .catch((err) => {
          return this.showToast(
            "Something went wrong! - Getting User Profile",
            "error"
          );
        });
    },
    async changeData(cycle, campusId) {
      this.fetchFees(campusId);
      this.getFundSources(campusId);
      await this.$store
        .dispatch("collection/getCollectionByCampus", { campusId, cycle: new Date().getFullYear() })
        .then((res) => {
          if (res.data.error) {
            this.showToast(res.data.errorMessage, "error");
            return false;
          }
          res.data.map(item => {
            item.visible = false;
            item.filterKey = `${item.payor} ${item.orNumber} ${item.amount}`;
          });
          this.collections = res.data;
      });
    },
    verifyNow(code) {
      this.$store
        .dispatch("verification/verifyCode", {
          code: code,
          type: this.verificationType,
        })
        .then((res) => {
          if (res.data.error) {
            this.showToast(res.data.errorMessage, "error");
            return false;
          }
          this.$bvModal.hide("verify-modal");
      });
    },
    filtered(type) {
      if(type == "unposted"){
        return this.collections.filter((collection) => {
          return !collection.isPosted && !collection.voided;
        });
      }
      if(type == "posted"){
        return this.collections.filter((collection) => {
          return collection.isPosted && !collection.voided;
        });
      }
      return this.collections.filter((collection) => {
        return collection.voided;
      });
    },
    renderSelection() {
      this.reportList = true;
      this.slideNum = 1;
      this.$nextTick(() => {
        this.$refs.carousel.goToPage(0);
      });
    },
    goBackToSelection() {
      this.slideNum = 1;
      this.reportSelection = 0;
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    goToSelection(type) {
      this.$v.selectedRange.$reset();
      let newDate = new Date();
      newDate.setFullYear(newDate.getFullYear(), 0, 1);
      let lastDate = new Date(newDate.getFullYear(), 11, 31);
      this.selectedRange = [newDate, lastDate];
      this.slideNum = 2;
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
      this.reportSelection = type;
    },
    generateCR(){
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/CashReceipts",
        routeVariables: [this.$store.state.data.selectedCampus.id],
        body: {
          cycle: this.$store.state.data.cycle,
          applicationUserId: this.userProfile.applicationUserId,
          dateFrom: this.getDate(this.selectedRange[0]),
          dateTo: this.getDate(this.selectedRange[1]),
        },
      });
      this.$bvModal.show("print-options-modal");
    },
    generateMCR(){
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/CollectionReportByOfficer",
        routeVariables: [this.$store.state.data.selectedCampus.id],
        body: {
          cycle: this.$store.state.data.cycle,
          applicationUserId: this.userProfile.applicationUserId,
          dateFrom: this.formatDateToISO(this.selectedRange[0]),
          dateTo: this.formatDateToISO(this.selectedRange[1]),
        },
      });
      this.$bvModal.show("print-options-modal");
    },
    generateCrep(){
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/CollectionReport",
        routeVariables: [this.$store.state.data.selectedCampus.id],
        body: {
          cycle: this.$store.state.data.cycle,
          dateFrom: this.formatDateToISO(this.selectedRange[0]),
          dateTo: this.formatDateToISO(this.selectedRange[1]),
        },
      });
      this.$bvModal.show("print-options-modal");
    },
    generateCrepCT(){
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/CollectionReport/CrossTab",
        routeVariables:  [this.$store.state.data.selectedCampus.id],
        body: {
          cycle: this.$store.state.data.cycle,
          dateFrom: this.formatDateToISO(this.selectedRange[0]),
          dateTo: this.formatDateToISO(this.selectedRange[1]),
        },
      });
      this.$bvModal.show("print-options-modal");
    },
    printReport() {
      this.$v.selectedRange.$touch();
      if (this.$v.selectedRange.$invalid) return;
      if(this.reportSelection == 'cr'){
        this.generateCR();
      }else if(this.reportSelection == 'mcr'){
        this.generateMCR();
      }else if(this.reportSelection == 'crep'){
        this.generateCrep();
      }else if(this.reportSelection == 'crep-ct'){
        this.generateCrepCT();
      }
    },
    postCollection(data) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to post this?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28c76f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, post it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("collection/postCollection", data.id)
            .then(async (response) => {
              if (response.data.error) {
                return this.showToast(response.data.errorMessage, "error");
              }
              let index = this.collections.findIndex(item => item.id === data.id);
              this.collections[index].isPosted = true;
              this.showToast("Collection posted successfully", "success");
            })
            .catch((error) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    voidCollection(data) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to void this?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ea5455",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, void it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("collection/voidCollection", data.id)
            .then(async (response) => {
              if (response.data.error) {
                return this.showToast(response.data.message, "error");
              }
              let index = this.collections.findIndex(item => item.id == data.id);
              this.collections[index].voided = true;
              this.collections[index].isPosted = false;
              this.showToast("Collection voided successfully", "success");
            })
            .catch((error) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    addCollection(){
      this.modalTitle = "Add Collection";
      this.$refs.collectionModal.resetForm();
      this.$bvModal.show("collection-modal");
    },
    editCollection(data){
      this.modalTitle = "Edit Collection";
      this.$refs.collectionModal.updateData(data);
      this.$bvModal.show("collection-modal");
    },
    submitCollection(modalData){
      modalData.campusId = this.$store.state.data.selectedCampus.id;
      if(modalData.id > 0){
          this.$store
            .dispatch("collection/updateCollection", modalData)
            .then((response) => {
                if (response.data.error) return this.showToast(response.data.errorMessage, "error");
                let index = this.collections.findIndex(item => item.id === modalData.id);
                let fs = this.fundSources.find(x => x.id === modalData.fundSourceId);
                modalData.fundSource = fs ?  fs.sourceName : '';
                this.collections.splice(index, 1, modalData);
                this.showToast("Collection updated successfully", "success");
                this.$bvModal.hide("collection-modal");
            })
            .catch((error) => {
                this.showToast("Something went wrong!", "error");
            });
      }else{
          this.$store
            .dispatch("collection/createCollection", modalData)
            .then((response) => {
                if (response.data.error) return this.showToast(response.data.errorMessage, "error");
                response.data.visible = false;
                response.data.filterKey = `${response.data.payor} ${response.data.orNumber} ${response.data.amount}`;
                this.collections.push(response.data);
                this.showToast("Collection created successfully", "success");
                this.$bvModal.hide("collection-modal");
            })
            .catch((error) => {
                this.showToast("Something went wrong!", "error");
            });
      }
    },
    deleteCollection(collection){
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ea5455",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("collection/removeCollection", collection.id)
            .then(async (response) => {
              if (response.data.error) {
                return this.showToast(response.data.errorMessage, "error");
              }
              let index = this.collections.findIndex(item => item.id === collection.id);
              this.collections.splice(index, 1);
              this.showToast("Collection deleted successfully", "success");
            })
            .catch((error) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    printReceipt(collection){
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Receipt",
        routeVariables: [collection.orNumber],
      });
      this.$bvModal.show("print-options-modal");
    },
  }
}
</script>
<template>
  <Layout @changeCycle="changeData($event, $store.state.data.selectedCampus.id)" @changeCampus="changeData($store.state.data.cycle, $event.id)">
    <PageHeader :title="title" :items="items" />
    <VerificationCode @dropCode="verifyNow" ref="verification" />
    <div class="text-right mb-2">
      <b-button id="select-report" 
        class="me-2" 
        variant="purple" 
            @click="renderSelection">
        <i class="bx bx-printer align-middle me-2"></i>Reports
      </b-button>
      <b-popover
        target="select-report"
        triggers="click"
        placement="left"
        custom-class="popover-report"
        :show.sync="reportList"
      >
        <template v-slot:title>
          <div
            class="
              d-flex
              align-items-center
              justify-content-between
            "
          >
              <small>Report List</small>
              <span
                  class="
                    bx bx-x
                    font-size-14
                    cursor-pointer
                  "
                  @click="reportList = false"
              ></span>
          </div>
        </template>
        <carousel
          ref="carousel"
          class="events navs-carousel custom-carousel"
          id="timeline-carousel"
          :navigation-enabled="false"
          :pagination-enabled="false"
          :perPage="1"
          :autoplay="false"
          :minSwipeDistance="0"
          :mouseDrag="false"
      >
          <slide>
            <div v-if="slideNum == 1">
              <div class="mb-0">
                <a
                  href="javascript:void(0);"
                  role="button"
                  class="font-size-12 text-dark hoverable-link"
                  @click="goToSelection('cr')"
                  >Cash Receipts</a
                >
              </div>
              <hr class="my-1 " />
              <div class="mb-0">
                <a
                  href="javascript:void(0);"
                  role="button"
                  class="font-size-12 text-dark hoverable-link"
                  @click="goToSelection('mcr')"
                  >My Collection Report</a
                >
              </div>
              <hr class="my-1 " />
              <div class="mb-0">
                <a
                  href="javascript:void(0);"
                  role="button"
                  class="font-size-12 text-dark hoverable-link"
                  @click="goToSelection('crep')"
                  >Collection Report</a
                >
              </div>
              <hr class="my-1 " />
              <div class="mb-0">
                <a
                  href="javascript:void(0);"
                  role="button"
                  class="font-size-12 text-dark hoverable-link"
                  @click="goToSelection('crep-ct')"
                  >Collection Report (Cross Tab)</a
                >
              </div>
            </div>
          </slide>
          <slide>
            <div v-if="slideNum == 2" class="">
              <a
                href="javascript:void(0);"
                class="
                    text-dark
                    d-flex
                    align-items-center
                    mb-2
                "
                @click="goBackToSelection"
                ><i class="bx bx-left-arrow-alt me-1"></i>Go back to selection
              </a>
              <label for="dateRange">Date Range</label>
              <date-picker
                v-model="selectedRange"
                :first-day-of-week="1"
                lang="en"
                range
                placeholder="Enter JEV Date..."
                :class="{ 'is-invalid': $v.selectedRange.$error }"
              >
              </date-picker>
              <div v-if="$v.selectedRange.$error" class="invalid-feedback">
                <span v-if="!$v.selectedRange.required">Date range is required.</span>
              </div>
              <button
                type="button"
                @click="printReport"
                class="btn btn-purple btn-sm btn-block mt-2"
            >
                <i class="bx bx-printer me-1"></i>
                Generate Report
            </button>
            </div>
          </slide>
        </carousel>
      </b-popover>
      <b-button variant="primary" @click="addCollection">
        <i class="bx bx-list-plus align-middle me-2 font-size-18"></i>
        Add collection
      </b-button>
    </div>
    <b-tabs
      v-model="tabModel"
      pills
      vertical
      nav-class="p-0"
      nav-wrapper-class="col-sm-2 border-end"
      content-class="pt-0 px-2 text-muted"
    >
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-bookmark-minus"></i>
          </span>
          <span class="d-none d-sm-inline-block"><i class="bx bx-bookmark-minus me-1"></i>Unposted</span>
        </template>
        <CollectionList 
          :loading="loading"
          type="unposted"
          :collections="filtered('unposted')"
          @edit="editCollection"
          @delete="deleteCollection"
          @post="postCollection"
          @void="voidCollection"
          @print="printReceipt"
        />
      </b-tab>
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-add-to-queue"></i>
          </span>
          <span class="d-none d-sm-inline-block"><i class="bx bx-add-to-queue me-1"></i>Posted</span>
        </template>
        <CollectionList 
          :loading="loading"
          type="posted"
          :collections="filtered('posted')"
          @print="printReceipt"
        />
      </b-tab>
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-error-circle"></i>
          </span>
          <span class="d-none d-sm-inline-block"><i class="bx bx-error-circle me-1"></i>Voided</span>
        </template>
        <CollectionList 
          :loading="loading"
          type="voided"
          :collections="filtered('voided')"
          @print="printReceipt"
        />
      </b-tab>
    </b-tabs>
    <print-options ref="printOpt"></print-options>
    <CollectionModal 
      ref="collectionModal"
      :modalTitle="modalTitle"
      :fees="fees"
      :fundSources="fundSources"
      @submit="submitCollection"
    />
  </Layout>
</template>